export const addQueryParams = (
  pathname: string,
  page: number,
  size: number
) => {
  return window.history.replaceState(
    {},
    "",
    `${pathname}?page=${page}&limit=${size}`
  );
};
